import * as yup from "yup";
import { validationSchemas } from "../data";
export const branchReceipt = yup.object().shape({
  branchName: validationSchemas.name,
  storeName: validationSchemas.name,
});
